module.exports = __webpack_public_path__ + "img/popup_button_pre_ok_2.9bbbf88a.png";